// extracted by mini-css-extract-plugin
export default {"l_Copy_main":"Copy_l_Copy_main__UlJjq","l_Copy_icon":"Copy_l_Copy_icon__VEEWL"};